// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"Stack_horizontal__YC1sV","vertical":"Stack_vertical___r4jJ","root":"Stack_root__jD_F8"};